module.exports = __webpack_public_path__ + "img/charging-hub-realized-proprietary.70db7043.png";